import React, { useState, useEffect } from 'react';
import '../css/Header.css';

function Header({ homeRef, aboutRef, servicesRef, contactRef }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const scrollToRef = (ref) => {
        ref.current.scrollIntoView({behavior: 'smooth'});
        setIsMenuOpen(false);
    };

    const handleKeyDown = (e, callback) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            callback();
        }
    };

    return (
        <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
          <div className='mobileCorrection'>
            <div className="logo">
                Gleason Development
            </div>
            <div
                className={`hamburger ${isMenuOpen ? 'open' : ''}`}
                onClick={toggleMenu}
                onKeyDown={(e) => handleKeyDown(e, toggleMenu)}
                role="button"
                aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
                aria-expanded={isMenuOpen}
                aria-controls="main-navigation"
                tabIndex={0}
            >
                <div></div>
                <div></div>
                <div></div>
            </div>
          </div>
            <nav
                id="main-navigation"
                className={`navigation ${isMenuOpen ? 'open' : ''}`}
                aria-label="Main navigation"
            >
                <ul>
                    <li>
                        <a
                            href="#home"
                            onClick={(e) => {e.preventDefault(); scrollToRef(homeRef);}}
                            onKeyDown={(e) => handleKeyDown(e, () => scrollToRef(homeRef))}
                        >
                            Home
                        </a>
                    </li>
                    <li>
                        <a
                            href="#about"
                            onClick={(e) => {e.preventDefault(); scrollToRef(aboutRef);}}
                            onKeyDown={(e) => handleKeyDown(e, () => scrollToRef(aboutRef))}
                        >
                            About Us
                        </a>
                    </li>
                    <li>
                        <a
                            href="#services"
                            onClick={(e) => {e.preventDefault(); scrollToRef(servicesRef);}}
                            onKeyDown={(e) => handleKeyDown(e, () => scrollToRef(servicesRef))}
                        >
                            Services
                        </a>
                    </li>
                    <li>
                        <a
                            href="#contact"
                            onClick={(e) => {e.preventDefault(); scrollToRef(contactRef);}}
                            onKeyDown={(e) => handleKeyDown(e, () => scrollToRef(contactRef))}
                        >
                            Contact
                        </a>
                    </li>
                </ul>
            </nav>
        </header>
    );
}

export default Header;
